import type { ReactNode } from 'react';
import { cn } from '@shared/utils/utils';

interface InvitationLayoutProps {
  children: ReactNode;
  welcomeTitle: string;
  welcomeDescription: string;
  contentClassName?: string;
}

/** Shell compartido por el alta por invitación y su primer paso de preferencias. */
export function InvitationLayout({
  children,
  welcomeTitle,
  welcomeDescription,
  contentClassName,
}: InvitationLayoutProps) {
  return (
    <div className="mx-auto">
      <div className="h-svh min-height pt-4 text-body-text md:grid md:grid-cols-[55%_45%] md:pt-0">
        <main className="flex h-full min-h-0 w-full justify-center md:items-center">
          <div className={cn('w-full max-w-96 p-8 md:p-0', contentClassName)}>{children}</div>
        </main>
        <aside className="hidden h-full w-full items-center justify-center bg-element-bg md:flex">
          <div className="fixed right-0 top-0 px-10 pt-8">
            <img src="/imagen/logo_beeping_white.svg" alt="logo" className="h-[26px] w-[180px] object-contain" />
          </div>
          <div className="flex w-96 max-w-full flex-col items-center justify-center pt-11">
            <h2 className="text-[35px] font-bold">{welcomeTitle}</h2>
            <p className="text-base leading-relaxed">{welcomeDescription}</p>
            <div className="flex w-96 max-w-full items-center justify-center gap-4">
              <img src="/imagen/login.png" alt="" className="object-contain" />
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}
